import axios from 'axios';
import { Message } from 'element-ui'
function MyMessage(option) {
  Message.closeAll()
  Message(option)
}
MyMessage.error = function (option) {
  Message.closeAll()
  Message.error(option)
}
MyMessage.warning = function (option) {
  Message.closeAll()
  Message.warning(option)
}
const server = axios.create({
  // baseURL: 'http://101.37.25.211:8082',
  baseURL: process.env.BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

server.interceptors.request.use(config => {
  let cookie = localStorage.getItem('sessionId');
  if (cookie) {
    config.headers.ncac_sessionId = cookie;
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// 添加一个响应拦截器
server.interceptors.response.use(function (res) {
  // 在这里对返回的数据进行处理
  if (res.data.title === '没有登录' || (res.data.query && res.data.query.title === '没有登录')) {
    localStorage.clear();
    window.location.reload();
  }
  if (res.status === 200) {
    return res.data;
  }
}, function (err) {
  // Do something with response error
  MyMessage.error('系统开了个小差，请稍后再试');
  return Promise.reject(err);
});

export default server



// WEBPACK FOOTER //
// ./src/utils/request.js